export const FILTER_TYPE = {
    all: 'all',
    pending: 'pending',
    active: 'active'
}
